import { render } from "./CadastroPlanoDialog.vue?vue&type=template&id=3efa6110&scoped=true"
import script from "./CadastroPlanoDialog.vue?vue&type=script&lang=js"
export * from "./CadastroPlanoDialog.vue?vue&type=script&lang=js"

import "./CadastroPlanoDialog.vue?vue&type=style&index=0&id=3efa6110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa6110"]])

export default __exports__